import React, { useRef, useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import IMask from 'imask';
import { useNavigate } from 'react-router-dom';
import Loading from '../../components/loading';
import ErrorMessage from '../../components/errorMessage';
import logo from '../../assets/logo_sigo.png';
import { usePatientAppLogin } from './hooks/usePatientAppLogin';

export default function LoginForm() {
  const navigate = useNavigate();
  const { login } = usePatientAppLogin();

  const cpfMask = useRef(null);

  const [isLoading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [cpf, setCpf] = useState('');
  const [birthDate, setBirthDate] = useState(null);

  function applyMaskDefinition(inputRef) {
    if (!inputRef) return;
    const mask = IMask(inputRef, { mask: '000.000.000-00' });
    mask.on('accept', () => setCpf(mask.value));
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!cpf || !birthDate) {
      setShowErrorMessage(true);
      setErrorMessage('Por favor, preencha todos os campos.');
      return;
    }

    setLoading(true);

    const input = {
      cpf: cpf,
      birthday: birthDate.format('YYYY-MM-DD'),
    };

    login(input)
      .then((returnFromApi) => {
        sessionStorage.setItem('token', returnFromApi.data.token);
        navigate('/patient-app/home');
      })
      .catch((returnFromApi) => {
        setLoading(false);
        setShowErrorMessage(true);
        setErrorMessage(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
      });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          bgcolor: 'grey.100',
          p: 2,
        }}
      >
        <Card sx={{ width: '100%', maxWidth: 400, borderRadius: 4, p: 2 }} elevation={2}>
          <Loading isToHidden={isLoading === false} />
          {showErrorMessage && (
            <ErrorMessage
              message={errorMessage}
              show={showErrorMessage}
              setShow={setShowErrorMessage}
            />
          )}
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <img src={logo} alt="Logo" style={{ maxWidth: 220, objectFit: 'contain' }} />
            </Box>
            <Typography variant="h6" align="center" sx={{ mb: 3 }}>
              Acesse sua conta
            </Typography>
            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="CPF"
                placeholder="000.000.000-00"
                value={cpf}
                inputRef={(ref) => {
                  cpfMask.current = ref;
                  applyMaskDefinition(ref);
                }}
                onChange={(e) => setCpf(e.target.value)}
                sx={{ mb: 3 }}
                autoFocus
              />
              <DatePicker
                label="Data de Nascimento"
                value={birthDate}
                onChange={(date) => setBirthDate(date)}
                format="DD/MM/YYYY"
                sx={{ width: '100%', mb: 3 }}
              />
              <Button fullWidth variant="contained" type="submit" size="large">
                Entrar
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </LocalizationProvider>
  );
}
